import { Component, OnInit, OnDestroy } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { slide } from "../../../../app.route.animation";
import { ClientType } from "../../../services/com/comEnvironmentClient";
import { CoreCOMService } from "../../../services/com.service";
import { Subscription } from "rxjs";
import { MainnavService, ViewType } from "../../../components/mainNav/mainnav.service";

/** MainLayoutComponent was called, when app is initilized */

@Component({
  selector: "main-layout",
  templateUrl: "./mainLayout.component.html",
  styleUrls: ["./mainLayout.component.scss"],
  animations: [slide]
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  private _viewTypeSubscription: Subscription;
  public outletHeight: number;
  private _vh: number;
  private allowUp: boolean;
  private allowDown: boolean;
  private slideBeginY: number;
  constructor(private _mainnavService: MainnavService,
    private _coreCOMService: CoreCOMService) {
  }

  ngOnInit() {
    const me = this;

    this._vh = +(document.documentElement.style.getPropertyValue("--vh").replace("px", ""));

    if (this._coreCOMService.environment.client.type === ClientType.ios) {
      const pageScroll = document.getElementById("page");
      pageScroll.addEventListener("touchstart", function (event) {
        me.allowUp = (this.scrollTop > 0);
        me.allowDown = (this.scrollTop < this.scrollHeight - this.clientHeight);
        me.slideBeginY = event.targetTouches[0].pageY;
      });

      pageScroll.addEventListener("touchmove", function (event) {
        const up = (event.targetTouches[0].pageY > me.slideBeginY);
        const down = (event.targetTouches[0].pageY < me.slideBeginY);
        me.slideBeginY = event.targetTouches[0].pageY;
        if ((up && me.allowUp) || (down && me.allowDown)) {
          event.stopPropagation();
        } else {
          event.preventDefault();
        }
      });
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if(me._viewTypeSubscription){
      me._viewTypeSubscription.unsubscribe();
    }
  }

  public getRouterOutlet(outlet: RouterOutlet) {
    const me = this;
    const routeanimation = outlet && outlet.activatedRouteData && outlet.activatedRouteData["animation"];
    if (routeanimation) {
      return routeanimation;
    } else {
      return outlet.isActivated ? outlet.activatedRoute : "";
    }
  }

}
